import React from 'react';
import triangulos from '../assets/img/triangulos.png';
import rayas from '../assets/img/rayas.png';
import triangulos_colores from '../assets/img/triangulos_colores.png';

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      width:0
    }
  }

  render(){
    const {width} = this.props;
    return(
      <div className="Todo Index" style={{display:'flex', flexDirection:'column', alignItems:'flex-start', justifyContent:'flex-start', position:'relative'}}>
        <div style={{margin:20, display:'flex', flexDirection:'column'}}>
          <div style={{display:'flex', flexDirection:'column', marginBottom:40}}>
            <div style={{display:'flex', flexDirection:'row', width:"100%", overflowX:"hidden"}}>
              <div style={{display:'flex', flexDirection:'column', paddingBottom:20}}>
                <span className="Titulo" style={{lineHeight: width<500 ? '55px' : '40px'}} >OFICIOS</span>
              </div>
              {width >= 500 &&
                <img
                  style={{position:'relative', paddingTop:30}}
                  src={triangulos_colores}
                  height={70}
                  className="Logo"
                  alt="Logo"
                />
              }
              {width < 500 &&
                <img
                  style={{position:'absolute', zIndex:-1, left:0, top:-160}}
                  src={rayas}
                  width={width}
                  height={200}
                  className="Logo"
                  alt="Logo"
                />
              }
            </div>
          </div>
        </div>

        {width >= 500 &&
          <img
            style={{position:'absolute', right:50, top:-130, zIndex:-1}}
            src={triangulos}
            height={600}
            className="Logo"
            alt="Logo"
          />
        }
      </div>
    );
  }
}
